"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _button = _interopRequireDefault(require("@clayui/button"));

var _core = require("@clayui/core");

var _icon = _interopRequireDefault(require("@clayui/icon"));

var _shared = require("@clayui/shared");

var _react = _interopRequireDefault(require("react"));

var _Helpers = require("./Helpers");

var _Select = _interopRequireDefault(require("./Select"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * SPDX-FileCopyrightText: © 2019 Liferay, Inc. <https://liferay.com>
 * SPDX-License-Identifier: BSD-3-Clause
 */
var ClayDatePickerDateNavigation = function ClayDatePickerDateNavigation(_ref) {
  var ariaLabels = _ref.ariaLabels,
      currentMonth = _ref.currentMonth,
      disabled = _ref.disabled,
      months = _ref.months,
      onDotClicked = _ref.onDotClicked,
      onMonthChange = _ref.onMonthChange,
      spritemap = _ref.spritemap,
      years = _ref.years;

  /**
   * Handles the change of the month from the available
   * years in the range
   */
  function handleChangeMonth(month) {
    var date = (0, _Helpers.setMonth)(years, month, currentMonth);

    if (date) {
      onMonthChange(date);
    }
  }
  /**
   * Handles the previous month button
   */


  var handlePreviousMonthClicked = function handlePreviousMonthClicked() {
    return handleChangeMonth(-1);
  };
  /**
   * Handles the next month button
   */


  var handleNextMonthClicked = function handleNextMonthClicked() {
    return handleChangeMonth(1);
  };

  return /*#__PURE__*/_react.default.createElement("div", {
    className: "date-picker-calendar-header"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "date-picker-nav"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "date-picker-nav-item input-date-picker-month"
  }, /*#__PURE__*/_react.default.createElement(_Select.default, {
    disabled: disabled,
    name: "month",
    onChange: function onChange(event) {
      return onMonthChange(new Date(currentMonth.getFullYear(), Number(event.target.value)));
    },
    options: months,
    testId: "month-select",
    value: currentMonth.getMonth()
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "date-picker-nav-item input-date-picker-year"
  }, /*#__PURE__*/_react.default.createElement(_core.Picker, {
    UNSAFE_behavior: "secondary",
    className: "form-control-sm",
    disabled: disabled,
    items: years,
    native: true,
    onKeyDown: function onKeyDown(event) {
      if (event.shiftKey && (event.key === _shared.Keys.Up || event.key === _shared.Keys.Down)) {
        event.key = event.key === _shared.Keys.Up ? 'PageUp' : 'PageDown';
      }
    },
    onSelectionChange: function onSelectionChange(key) {
      return onMonthChange(new Date(Number(key), currentMonth.getMonth()));
    },
    selectedKey: String(currentMonth.getFullYear()),
    width: 85
  }, function (item) {
    return /*#__PURE__*/_react.default.createElement(_core.Option, {
      key: item.value
    }, String(item.label));
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "date-picker-nav-controls date-picker-nav-item date-picker-nav-item-expand"
  }, /*#__PURE__*/_react.default.createElement(_button.default, {
    "aria-label": ariaLabels.buttonPreviousMonth,
    className: "nav-btn nav-btn-monospaced",
    disabled: disabled,
    displayType: null,
    onClick: handlePreviousMonthClicked,
    title: ariaLabels.buttonPreviousMonth
  }, /*#__PURE__*/_react.default.createElement(_icon.default, {
    spritemap: spritemap,
    symbol: "angle-left"
  })), /*#__PURE__*/_react.default.createElement(_button.default, {
    "aria-label": ariaLabels.buttonDot,
    className: "nav-btn nav-btn-monospaced",
    disabled: disabled,
    displayType: null,
    onClick: onDotClicked,
    title: ariaLabels.buttonDot
  }, /*#__PURE__*/_react.default.createElement(_icon.default, {
    spritemap: spritemap,
    symbol: "simple-circle"
  })), /*#__PURE__*/_react.default.createElement(_button.default, {
    "aria-label": ariaLabels.buttonNextMonth,
    className: "nav-btn nav-btn-monospaced",
    disabled: disabled,
    displayType: null,
    onClick: handleNextMonthClicked,
    title: ariaLabels.buttonNextMonth
  }, /*#__PURE__*/_react.default.createElement(_icon.default, {
    spritemap: spritemap,
    symbol: "angle-right"
  })))));
};

var _default = ClayDatePickerDateNavigation;
exports.default = _default;